import React from 'react';
import toastr from 'toastr';
class EditWidgetModalContent extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {};
    }

    componentDidMount() {
        this.props.onRef(this)
        this.setState({ location: this.props.nodeId });
    }
    componentWillUnmount() {
        this.props.onRef(undefined)
    }
    changeHandler(e) {
        let key = e.target.id;
        let value = e.target.value;
        this.setState({ [key]: parseInt(value) });
    }

    generateOptions(tree, options) {
        var self = this;
        if (tree.type != 'customer') {
            options.push(<option key={tree.id} value={tree.id}>{tree.info.name}</option>);
        }
        if (tree.children && tree.type != 'meeting_room' && tree.type != 'open_area') {
            tree.children.forEach(function (element) {
                if (element.type != "sensor") {
                    self.generateOptions(element, options);
                }
            });
        }
    }

    submit() {
        if (this.props.nodeId == this.state.location || this.props.widgetLocations.includes(this.state.location)) {
            toastr.error("The location already exists, please, choose a different location");
            return false
        }
        else {
            this.props.editWidget(this.props.nodeId, this.state.location);
            return true
        }
    }


    render() {
        let options = [];
        this.generateOptions(this.props.tree, options);
        return (
            <div>
                <div className="country">
                    <label style={{ paddingLeft: "20px", paddingBottom: '5px' }}>Location</label>
                    <select value={this.state.location} id="location" onChange={this.changeHandler.bind(this)}>
                        {options}
                    </select>
                </div>
            </div>
        );
    }
}

export default EditWidgetModalContent;


// WEBPACK FOOTER //
// ./src/components/common/widgets/locationbottommenu/editwidgetmodalcontent.jsx